import { useMemo } from 'react'
import { IDeveloperField } from 'dromo-uploader-react'
import { useGetOptions } from './useGetOptions'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'
import { sharedFieldSettings } from '../settings/sharedFieldSettings'
import { leadFieldSettings } from '../settings/leadFieldSettings'
import { ImportEntityType } from '../typings'
import { opportunityFieldSettings } from '../settings/opportunityFieldSettings'
import { useSelectCustomFieldData } from '@user/store/customFields'

export function useFieldSettings(
  entityType: ImportEntityType | undefined,
): IDeveloperField[] {
  const fieldOptions = useGetOptions()

  const { getFormat } = useLocalizationDateFormat()
  const dateFormat = getFormat()
  const customFieldData = useSelectCustomFieldData()

  const fieldsConfig = useMemo(() => {
    const sharedFields: IDeveloperField[] = sharedFieldSettings(
      fieldOptions,
      dateFormat,
    )

    // Import type-specific fields
    const typeSpecificFields: Record<ImportEntityType, IDeveloperField[]> = {
      [ImportEntityType.Lead]: [
        ...sharedFields,
        ...leadFieldSettings(fieldOptions, customFieldData, dateFormat),
      ],
      [ImportEntityType.Opportunity]: [
        ...sharedFields,
        ...opportunityFieldSettings(fieldOptions, dateFormat, customFieldData),
      ],
      [ImportEntityType.DraftLead]: [...sharedFields],
    }

    // Return the configuration based on importType
    return entityType !== undefined ? typeSpecificFields[entityType] : []
  }, [fieldOptions, dateFormat, customFieldData, entityType])

  return fieldsConfig
}
